import React from 'react';
import { ClientsUIProvider } from '../list/ClientsUIContext';
import ClientsMCTable from './table/ClientsMCTable';
import ClientDropHeader from './ClientDropHeader';
import ClientsDropMenu from './ClientsDropMenu';
import '../../../styles/sass/global/components/checker.scss';
import localStorage from 'redux-persist/es/storage';

export default function ClientsDrop ({ listDrop, calculateBadges, clientsDropBadges }) {
    const total = clientsDropBadges;
    localStorage.setItem('totalClientPending', total);
    return (
        <ClientsUIProvider>
            <ClientDropHeader/>
            <div className='menuFlex'>
                <div className='menuFlexLeft'>
                    <ClientsDropMenu clientsDropBadges={total}/>
                </div>
                <div className='menuFlexRight'>
                    <ClientsMCTable listDrop={listDrop} calculateBadges={calculateBadges} clientsDropBadges={clientsDropBadges} />
                </div>
            </div>
        </ClientsUIProvider>
    );
}
